import { baseClasses } from '@weatherbug/common';
const { PulseBaseProvider } = baseClasses;

const getFeaturedWeatherCamsCacheKey = 'getFeaturedWeatherCams';
const getCategoriesWeatherCamsCacheKey = 'getCategoriesWeatherCameras';

const getFeaturedCategoryWeatherCamsUri = '/api/weathercamera/category-cameras';

// Because returned response fails test in syncData response check, this validation function just adds result key response.
const getFeaturedCategoryWeatherCamsValidationFunction = (result) => {
    return result && Array.isArray(result);
};
export class FeaturedCategoryWeatherCamProvider extends PulseBaseProvider {
    constructor(authId, secret, options, logger) {
        super(authId, secret, options, logger);
        window.storage.sync[getFeaturedWeatherCamsCacheKey] = this.getFeaturedWeatherCamsSyncer.bind(this);
        window.storage.sync[getCategoriesWeatherCamsCacheKey] = this.getCategoriesWeatherCamsSyncer.bind(this);
    }

    async getFeaturedWeatherCamsSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters
            , category: syncParams.category
            , count: syncParams.numberOfFeaturedCams
            , verbose: syncParams.verbose
        };

        return await super.syncData( syncParams.key,
                                    id,
                                    queryParams,
                                    getFeaturedCategoryWeatherCamsUri,
                                    resolve,
                                    reject,
                                    getFeaturedCategoryWeatherCamsValidationFunction,
                                    syncParams.pulseApi,
                                    null,
                                    null,
                                    false );
    }

    async getFeaturedWeatherCams(category, numberOfFeaturedCams = 5, verbose, stdParameters, refresh = false) {
        const syncParams = {
            verbose: !!verbose,
            category,
            numberOfFeaturedCams,
            refresh
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh)
        {
            super.removeFromStorage(getFeaturedWeatherCamsCacheKey, id);
        }
        return await super.loadFromStorage(getFeaturedWeatherCamsCacheKey, id, syncParams);
    }

    async getCategoriesWeatherCamsSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters
            , category: syncParams.category
            , count: syncParams.numberOfCategoryCams
            , verbose: syncParams.verbose
        };

        return await super.syncData( syncParams.key,
                                    id,
                                    queryParams,
                                    getFeaturedCategoryWeatherCamsUri,
                                    resolve,
                                    reject,
                                    getFeaturedCategoryWeatherCamsValidationFunction,
                                    syncParams.pulseApi,
                                    null,
                                    null,
                                    false );
    }

    async getCategoriesWeatherCams(category, numberOfCategoryCams = 8, verbose, stdParameters, refresh = false) {
        const syncParams = {
            verbose: !!verbose,
            category,
            numberOfCategoryCams,
            refresh
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh)
        {
            super.removeFromStorage(getCategoriesWeatherCamsCacheKey, id);
        }
        return await super.loadFromStorage(getCategoriesWeatherCamsCacheKey, id, syncParams);
    }
}
